import { IModelEntity } from '@pit/core';
import { IDtoContact } from './dto.contact.interface';

export interface IDtoDepot extends IModelEntity {

    accountPrefix?: string;
    numberDepot?: string;
    name?: string;

    contacts?: IDtoContact[];

    completeDescription?: string;

}
